import { Pipe, PipeTransform } from '@angular/core';
import { TableRowType } from "../services/table-data/ITable";

@Pipe({
    name: 'isRowType'
})
export class IsRowTypePipe implements PipeTransform {
    public transform(elementType: TableRowType, testedType: TableRowType|TableRowType[]): boolean {
        const testedTypeArray: TableRowType[] = Array.isArray(testedType) ? testedType : [testedType];
        return testedTypeArray.includes(elementType);
    }
}
